import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "custom-pagination-select"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
  tableModel: {
    type: Object,
    required: true,
  },
  pageSizesList: {
    type: Object,
  },
  showPageSizeSelect: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

const onUpdateItemsPerPage = (value) => {
  props.tableModel.bind.itemsPerPage = parseInt(value, 10);
  props.tableModel.bind.options.itemsPerPage = parseInt(value, 10);
  props.tableModel.bind.options.page = 1;
  props.tableModel.reload();
};

const onUpdatePage = (value) => {
  props.tableModel.bind.options.page = parseInt(value, 10);
  props.tableModel.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "custom-pagination mt-6" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_pagination, {
        class: "ma-auto",
        length: props.tableModel.bind.pageCount,
        "model-value": props.tableModel.bind.options.page,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (pageSize) => onUpdatePage(pageSize)),
        rounded: ""
      }, null, 8 /* PROPS */, ["length", "model-value"]),
      (__props.showPageSizeSelect)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('На странице по:')), 1 /* TEXT */),
            _createVNode(_component_v_select, {
              variant: "plain",
              class: "custom-pagination-select-box",
              items: props.pageSizesList,
              "model-value": props.tableModel.bind.itemsPerPage,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = (pageSize) => onUpdateItemsPerPage(pageSize)),
              "hide-details": "",
              "menu-icon": ""
            }, null, 8 /* PROPS */, ["items", "model-value"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})